// import { Import } from "lucide-react";
import { OK } from "zod";

const BASE_URL = import.meta.env.VITE_API_BASE;
const BASE_URL_REQUEST = import.meta.env.VITE_API_BASE_REQUEST;
async function makeAuthenticatedRequest(endpoint, username, password, options = {}) {
  console.log("Making request to:", endpoint);
  console.log("With options:", options);

  const res = await fetch(endpoint, {
    headers: {
      ...options.headers,
      Authorization: "Basic " + btoa(`${username}:${password}`),
    },
    body: options.body,
    method: options.method || "GET",
    credentials: 'include', // Include cookies in the request
  });

  if (!res.ok) {
    throw new Error(`PAS API error: ${res.status} ${res.statusText}`);
  }

  const data = await res.json();
  return data;
}
async function makeAuthenticatedPostRequest(endpoint, username, password, options = {}) {
  console.log("Making request to:", endpoint);
  console.log("With options:", options);
  try {
    const res = await fetch(endpoint, {
      headers: {
        ...options.headers,
        Authorization: "Basic " + btoa(`${username}:${password}`),
      },
      body: options.body,
      method: options.method || "GET",
      credentials: 'include', // Include cookies in the request
    });
    if (!res.ok) {
      throw new Error(`PAS API error: ${res.status} ${res.statusText}`);
    }
    console.log("Response:", JSON.stringify(res));
    return OK;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

export async function getAttendance(username, password, email, full = false) {
  const endpoint = `${BASE_URL}.get_attendance?email=${encodeURIComponent(
    email
  )}`;
  const data = await makeAuthenticatedRequest(endpoint, username, password);

  if (full) {
    return data.message;
  }
  return (data.message || []).slice(0, 3);
}

export async function getSummary(username, password, email) {
  const endpoint = `${BASE_URL}.summary?email=${encodeURIComponent(email)}`;
  const data = await makeAuthenticatedRequest(endpoint, username, password);

  return data.message;
}
export async function getTasks(username, password, email) {
  const endpoint = `${BASE_URL}.tasks?email=${encodeURIComponent(email)}`;
  const data = await makeAuthenticatedRequest(endpoint, username, password);

  return data.message || [];
}

export async function getMyDocument(username, password, emp_id) {
  const endpoint = `${BASE_URL}.get_employee_attachments?employee=${encodeURIComponent(
    emp_id
  )}`;
  const data = await makeAuthenticatedRequest(endpoint, username, password);

  return data.message;
}


export async function getMyRequests(username, password, emp_id) {
  const endpoint = `${BASE_URL}.requests?employee=${encodeURIComponent(
    emp_id
  )}`;
  const data = await makeAuthenticatedRequest(endpoint, username, password);

  return data.message;
}

export async function sendRemoteWorkRequest(username, password, requestData) {
  console.log("Request Data:", requestData);
  const endpoint = `${BASE_URL_REQUEST}Work Outside Office Permission`;
  try {
    const res = await makeAuthenticatedRequest(endpoint, username, password, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "token cc84f7fb285:30f343f9b99",
        "Cookie": "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
      },
      body: JSON.stringify(requestData),
    });
    return res;
  }
  catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }


}

export async function sendLeavePermissionRequest(username, password, requestData) {
  console.log("Request Data:", requestData);
  const endpoint = `${BASE_URL_REQUEST}Leave Permission`;
  try {
    const res = await sendLeaveApplicationRequest(endpoint, username, password, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "token cc84f7fb285:30f343f9b99",
        "Cookie": "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
      },
      body: JSON.stringify(requestData),
    });
    return res;
  }
  catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }

}

export async function getLeaveTypes(username, password) {
  const endpoint = `${BASE_URL}.leave_types`;
  const data = await makeAuthenticatedRequest(endpoint, username, password);

  return data.message;
}
export async function getLeaveTypeBalance(username, password, emp_id, leave_type = '') {
  const endpoint = `${BASE_URL}.leave_balance?employee=${encodeURIComponent(
    emp_id
  )}&&leave_type=${leave_type}&from_date=2025-10-10&to_date=2025-10-12`;
  const data = await makeAuthenticatedRequest(endpoint, username, password, emp_id);

  return data.message;
}
export async function sendLeaveApplicationRequest(username, password, requestData) {
  console.log("Request Data:", requestData);
  const endpoint = `${BASE_URL_REQUEST}Leave Application`;
  try {
    const res = await makeAuthenticatedPostRequest(endpoint, username, password, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "token cc84f7fb285:30f343f9b99",
        "Cookie": "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
      },
      body: JSON.stringify(requestData),
    });
    return res;
  }
  catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }


}
export async function sendTechnicalSupportRequest(username, password, requestData) {
  console.log("Request Data:", requestData);
  const endpoint = `${BASE_URL_REQUEST}IT Support Request`;
  try {
    const res = await makeAuthenticatedPostRequest(endpoint, username, password, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "token cc84f7fb285:30f343f9b99",
        "Cookie": "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
      },
      body: JSON.stringify(requestData),
    });
    return res;
  }
  catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }


}
